<template>
    <div class="print-pay-slip">
        <!-- component goes here -->
        <PayslipTable v-if="payslip && payslipSettings" :payslip="payslip" :payslipSettings="payslipSettings"/>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import Helper from "@utils/misc";
import PayslipTable from "@components/payroll/PayslipTable";
// import moment from "moment";

export default {
    name: 'PrintPayslip',
    data(){
        return{
            payslip: null,
            payslip_id: null,
            payslipSettings: null,

        }
    },
    components:{
        // component goes here
        PayslipTable,
    },
    computed:{
        ...mapGetters([
            "currentUser",
            "currentInstitution",
            "accessToken",
            "isLoading",
        ]),
        essentials() {
            return {
                accessToken: this.accessToken,
                setLoading: this.setLoading,
                handleErrorsFunction: this.handleApiErrors,
            };
        },
    },
    methods:{
        ...mapActions(['setLoading','unsetCurrentUser']),
        async getPayslipData(){
            var url = Helper.addUrlParams(endpoints.payslip,[`id=${this.payslip_id}`])
            this.payslip = await api.call(
                this.essentials,
                url
            )
            document.title = `${
                this.payslip.account.staff_hr_account.staff.full_name
            } -  ${this.payslip.payslip_group.title} | Payslip`
            document.readyState;
            window.onfocus = function(){
                window.close();
            }
        },
        async getPayslipSettings(){
            this.payslipSettings = await api.call(this.essentials, endpoints.payslipSettings)
        },   
        docReady(fn){
            // see if DOM is already available
            if(
                document.readyState === 'complete' || 
                document.readyState === 'interative'
            ){
                setTimeout(fn,1);
            }else{
                document.addEventListener("DOMContentLoaded",fn)
            }
        },     
    },
    
    created(){
        this.payslip_id = this.$route.params.payslip_id
        this.unsetCurrentUser();
        this.getPayslipData();
        this.getPayslipSettings();
        var self = this;
        setTimeout(()=> self.docReady(print()), 500)
    }
}
</script>

<style type="text/css" media="print" scoped>
@page {
  size: auto; /* auto is the initial value */
  margin: 0; /* this affects the margin in the printer settings */
}
</style>